// CSS custom properties for the help center, from the "ExoPaper Help Center" design.
// Scoped to the documentation layout root, keyed by the app's MUI palette mode.
export const helpVars = (mode) =>
  mode === 'dark'
    ? {
        '--bg': '#272c36',
        '--panel': '#313743',
        '--panel2': '#3a414f',
        '--text': '#dbe1ec',
        '--text2': '#8e99ad',
        '--border': '#414959',
        '--accent': '#3fc6e4',
        '--accent-strong': '#5dd2ec',
        '--accent-soft': 'rgba(63,198,228,.12)',
        '--accent-border': 'rgba(63,198,228,.45)',
        '--shadow': '0 1px 3px rgba(0,0,0,.25),0 6px 20px rgba(0,0,0,.18)',
        '--code-bg': '#1e232c',
        '--green': '#66bb6a',
        '--amber': '#f0a83f',
      }
    : {
        '--bg': '#eef1f6',
        '--panel': '#ffffff',
        '--panel2': '#f6f8fb',
        '--text': '#3d4a5d',
        '--text2': '#8492a6',
        '--border': '#e3e8f0',
        '--accent': '#2ab7d8',
        '--accent-strong': '#1795b4',
        '--accent-soft': 'rgba(42,183,216,.10)',
        '--accent-border': 'rgba(42,183,216,.45)',
        '--shadow': '0 1px 3px rgba(61,74,93,.06),0 4px 16px rgba(61,74,93,.05)',
        '--code-bg': '#252b36',
        '--green': '#43a047',
        '--amber': '#ef9a1f',
      };
